"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVT_UPDATE_BOOKING = 'EVT_UPDATE_BOOKING';
exports.EVT_UPDATE_LICENSE = 'EVT_UPDATE_LICENSE';
exports.EVT_CHECK_MAC_EQUIPMENT = 'EVT_CHECK_MAC_EQUIPMENT';
exports.EVT_CREATE_BUCKET_BANNER = 'EVT_CREATE_BUCKET_BANNER';
exports.EVT_REMOVE_BUCKET_BANNER = 'EVT_REMOVE_BUCKET_BANNER';
//# sourceMappingURL=emitterKeys.js.map